import isFile from './isFile'

const isVideo = url => isFile(url, ['mp4', 'm4v', 'ogg', 'ogv', 'webm'])
export default isVideo
